import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import CompareBlock from './CompareBlock.jsx';
import uiLocale from '../../../utils/UILocale.js';
import initCompareSessionStorageProducts from './initCompareSessionStorageProducts';
import initCompareCheckboxes from './initCompareCheckboxes';

export default function initCompareBlock(mountEl, fromPDP) {
  const origin = fromPDP ? 'productpage' : 'productlisting';
  const translations = {
    compareLabel: uiLocale.getString('component.comparepanel.compare_button') ||
      uiLocale.getString('component.compare.compareCountLabel'),
    fromDateTranslation: uiLocale.getString(`component.${origin}.fromDateLabel`),
    toDateTranslation: uiLocale.getString(`component.${origin}.toLabel`),
    wasPriceTranslation: uiLocale.getString(`component.${origin}.wasLabel`),
    savingsPriceTranslation: uiLocale.getString(`component.${origin}.saveLabel`),
    clearAll: uiLocale.getString('component.comparepanel.clearAll'),
    addThisItem: uiLocale.getString('component.comparepanel.addThisProduct') || ''
  };

  ReactDOM.render(
    <Provider store={window.appState}>
      <CompareBlock translations={translations} />
    </Provider>, mountEl
  );

  initCompareSessionStorageProducts();
  initCompareCheckboxes();
}
